import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { documentTypesPartnerResources } from '@customer/store/apis/documentsApi';
import { setPartnerResourceTypes } from '@customer/store/slices/filtersSlice';
import { TechLibraryDocumentType } from '@cas/config/documents';

const usePartnerResourceTypesOptions = (): DropdownItemProps<TechLibraryDocumentType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return documentTypesPartnerResources
      .map((value: TechLibraryDocumentType) => ({
        key: value,
        value,
        stringValue: value,
        label: t(`DocType.${value}`),
      }))
      .sort(
        (
          a: DropdownItemProps<TechLibraryDocumentType>,
          b: DropdownItemProps<TechLibraryDocumentType>,
        ) => a.label.localeCompare(b.label),
      );
  }, [t]);
};

export const PartnerResourceTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<TechLibraryDocumentType>
      filterName="partnerResourceTypes"
      label={label ?? t('ResourceTypeTitle')}
      action={setPartnerResourceTypes}
      elementRef={elementRef}
      useItemsHook={usePartnerResourceTypesOptions}
    />
  );
};

export default PartnerResourceTypesFilter;
